import { apiForPrivate } from '.';
import { FILENAME_FORMATTER_ENDPOINT } from '../../config/ap';

const apiFilenameFormatters = apiForPrivate.injectEndpoints({
    overrideExisting: true,
    endpoints: build => ({
        getFilenameFormatter: build.query({
            query: id => `${FILENAME_FORMATTER_ENDPOINT.FILENAME_FORMATTERS}/${id}`,
        }),
        getFilenameFormatters: build.query({
            query: page => ({
                url: `${FILENAME_FORMATTER_ENDPOINT.FILENAME_FORMATTERS}`,
                params: page
            })
        }),
        addFilenameFormatter: build.mutation({
            query: payload => ({
                url: FILENAME_FORMATTER_ENDPOINT.FILENAME_FORMATTERS,
                method: 'POST',
                body: payload,
            }),
        }),
        updateFilenameFormatter: build.mutation({
            query: ({ id, payload }) => ({
                url: `${FILENAME_FORMATTER_ENDPOINT.FILENAME_FORMATTERS}/${id}`,
                method: 'PUT',
                body: payload,
            }),
        }),
        deleteFilenameFormatter: build.mutation({
            query: payload => ({
                url: `${FILENAME_FORMATTER_ENDPOINT.FILENAME_FORMATTERS}/${payload.id}`,
                method: 'DELETE'
            }),
        }),
    })
});

export const {
    useLazyGetFilenameFormatterQuery,
    useLazyGetFilenameFormattersQuery,
    useAddFilenameFormatterMutation,
    useUpdateFilenameFormatterMutation,
    useDeleteFilenameFormatterMutation,
} = apiFilenameFormatters;
